<template>
  <div class="guest-form card-border m-t-20">
    <div class="flexed justify-center align-center" style="min-height: 530px" v-if="loading">
      <loading ></loading>
    </div>
    <div class="w-100 p-20 m-b-10 form-controls" v-else>
      <span class="label-no-height title" style="">{{ $t("lbl_contact_information") }}</span>
      <fd-input
        key="first_name"
        v-model="contact_info.first_name"
        :placeholder="$t('lbl_first_name')"
        border-radius-bottom-right="0"
        border-radius-bottom-left="0"
        :autocomplete="false"
        control-name="first_name"
        :error="vValidateErrorHandler('first_name')"
        v-validate="{ required: isFieldRequired('first_name'), regex: rules.first_name_regex || ''}"
        :showAsterisk="isFieldRequired('first_name')"
      >
      </fd-input>
      <fd-input
        key="last_name"
        v-model="contact_info.last_name"
        :placeholder="$t('lbl_last_name')"
        border-radius-bottom-right="0"
        border-radius-bottom-left="0"
        :autocomplete="false"
        control-name="last_name"
        :error="vValidateErrorHandler('last_name')"
        v-validate="{ required: isFieldRequired('last_name'), regex: rules.last_name_regex || ''}"
        :showAsterisk="isFieldRequired('last_name')"
      />
      <fd-input
        key="email"
        v-model="contact_info.email"
        :placeholder="$t('lbl_email')"
        border-radius-bottom-right="0"
        border-radius-bototm-left="0"
        :autocomplete="false"
        control-name="email"
        :error="vValidateErrorHandler('email')"
        v-validate="{ required: true, regex: rules.email_regex || ''}"
        :showAsterisk="true"
      />
      <hk-phone-input :model.sync="contact_info.phone"
                      ref="hkPhoneInput"
                      :placeholder="$t('lbl_phone')"
                      key="phone"
                      control-name="phone"
                      autocomplete="new-password"
                      :defaultCountryCode="dynamicCountryCode"
                      classes="primary-phone" />

      <span class="label-no-height title" style="">{{ $t("lbl_address") }}</span>
      <fd-input
        key="street"
        v-model="contact_info.street"
        :placeholder="$t('lbl_street')"
        border-radius-bottom-right="0"
        border-radius-bototm-left="0"
        :autocomplete="false"
        control-name="street"
        class=" street"
      />
      <fd-input
        key="city"
        v-model="contact_info.city"
        :placeholder="$t('lbl_city')"
        border-radius-bottom-right="0"
        border-radius-bototm-left="0"
        :autocomplete="false"
        control-name="city"
      />
      <fd-input
        key="state_required"
        v-model="contact_info.state"
        data-vv-validate-on="input|blur"
        border-radius-bottom-right="0"
        border-radius-top-right="0"
        border-radius-top-left="0"
        control-name="state_required"
        justify-content="space-between"
        :placeholder="$t('lbl_state')"
        v-validate="{ required: !rules.state_optional}"
        :showAsterisk="isFieldRequired('state')"
      >
    <span v-if="rules && rules.property_eligible_states && rules.property_eligible_states.length > 0" @click="$refs.selectState.focus()" class="drop-down-label">
      <span v-if="rules.state_required" class="asterisk">*</span> {{$t('lbl_state')}}
    </span>
        <el-select
         v-if="rules && rules.property_eligible_states && rules.property_eligible_states.length > 0"
          v-model="contact_info.state"
          filterable
          :placeholder="$t('lbl_select')"
          class="border-0 text-right"
          size="mini"
          ref='selectState'
        >
          <el-option
            v-for="state in rules.property_eligible_states"
            :key="state.id"
            :label="state.state_code"
            :value="state.state_code"
          />
          <template slot="prefix" class="el-error" v-if="errors.has('state_required')"> <span class="el-error">{{ $t("lbl_required") }}</span> </template>
        </el-select>
      </fd-input>
      <fd-input
        key="zipcode_required"
        v-model="contact_info.zip_code"
        placeholder="Postal"
        border-radius-bottom-right="0"
        border-radius-bototm-left="0"
        :autocomplete="false"
        control-name="zipcode_required"
        v-validate="{ required: false}"
        :showAsterisk="false"
      />
      <fd-input
        key="country"
        v-model="contact_info.country"
        v-validate="{ required: isFieldRequired('country')}"
        :placeholder="$t('lbl_country')"
        :showAsterisk="isFieldRequired('country')"
        border-radius-bottom-right="0"
        border-radius-bototm-left="0"
        :autocomplete="false"
        control-name="country"
        justify-content="space-between"
      >
      <span @click="$refs.selectCountry.focus()" class="drop-down-label">
        <span v-if="isFieldRequired('country')" class="asterisk">*</span> {{$t('lbl_country')}}
    </span>
        <el-select
          v-model="contact_info.country"
          filterable
          :placeholder="$t('lbl_select')"
          class="border-0 text-right"
          size="mini"
          ref='selectCountry'
          @change="getAddressRules(contact_info.country)"
        >
          <el-option
            :key="_country.value"
            :value="_country.value"
            :label="_country.name"
            v-for="_country in countries">
          </el-option>
          <template slot="prefix" class="el-error" v-if="false"> <span class="el-error">{{ $t("lbl_required") }}</span> </template>
        </el-select>
      </fd-input>
      <!-- <fd-input
        key="remarks"
        v-model="contact_info.remarks"
        placeholder="Special Remarks (if any)"
        border-radius-bottom-right="0"
        border-radius-bototm-left="0"
        :autocomplete="false"
        control-name="remarks"
        class="street"
        isComponent="textarea"
        :style="'height: 94px'"
      /> -->
    </div>
  </div>

</template>

<script>
import HkPhoneInput from '@/components/hk-tel-input/HkPhoneInput.vue'
import FdInput from '@/components/FdInput.vue'
import {mapMutations, mapState} from "vuex";
import {Countries} from "../../../booking-v2/information/countries";
import  apiCallsActivities from '@/services/activities/api-calls-activities.service'
import loading from '@/components/common/loading.vue';

export default {
  name: "GuestForm",
  components: {HkPhoneInput, FdInput, loading},
  props:{
    loadingParent: Boolean
  },
  data() {
    return {
      contact_info: {
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        street: null,
        city: null,
        state: null,
        zip_code: null,
        country: null,
      },
      loading: false,
      countries: Countries,
      rules: null
    }
  },
  mounted() {

    // if(!this.guestData) {
    //   this.contact_info.country =  this.property.country
    // }
    // else {
    //   this.contact_info.country = this.guestData.country
    // }
    this.contact_info.country =  this.property.country
    this.contact_info.first_name = this.guestData.first_name;
    this.contact_info.last_name = this.guestData.last_name;
    this.contact_info.email = this.guestData.email;
    this.contact_info.phone = this.guestData.phone;
    this.contact_info.street = this.guestData.street
    this.contact_info.city = this.guestData.city
    this.contact_info.state = this.guestData.state
    this.contact_info.zip_code = this.guestData.zip_code
  },
  methods:{
    isFieldRequired(field_name){
      let valid = this.rules?.required_guest_fields.includes(field_name)

      return valid
    },
    async validateForm() {
      let valid = await this.$validator.validateAll()
       if(valid)
         return this.contact_info
    },
    vValidateErrorHandler(fieldName) {
        let message = null;
        if (this.errors?.has(fieldName)) {
            let feldRule = this.errors.items.find(item => item.field === fieldName);
            if (feldRule?.rule === 'required') message = 'Required';
            else if (feldRule?.rule === 'regex') message = 'Not valid';

        }
        return message;
    },
    async getAddressRules(){
      this.loading = true
      try{
        // TODO: make country_code dynamic
        let params = {
          country_code: this.contact_info?.country
        }

        let result = await apiCallsActivities.get(`${this.property.id}/address-rules?country_code=${params.country_code}&booking_flow=true`, null, 'baseAppUrlProperties')
        // hk-crs/properties
        // {host}/hk-crs/properties/{propertyId}/address-rules?country_code=US&booking_flow=true

        this.rules = result.data
        this.contact_info.state = ''
        this.loading = false
      }
      catch (e) {
        this.$notify.error({
          title: this.$t('lbl_error'),
          message: this.$t('lbl_something_went_wrong')
        })
      }
    }
  },
  computed:{
    ...mapState({
      property: state => state.activities.propertyDetails,
      guestData: state => state.activities.guestData
    }),
     dynamicCountryCode() {
      return this.contact_info.country;
    },
  },
  beforeMount() {
    this.contact_info.country =  this.property.country
    this.getAddressRules()
  }
}
</script>

<style scoped lang="scss">
@import '~css_vars';
@import "~mixins";
$gray: #b6b6b6;

.form-controls{
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px 10px;
  .label-no-height{
    color: black;
  }
  .street, .title{
    grid-column-start: 1;
    grid-column-end: -1;
  }
  .title{
    // margin-bottom: -10px;
    font-weight: bold;
    color: #4E4E4E;
  }


  .border-0 {
    ::v-deep  input {
      border: none  !important;
      text-align: right;
      font-size: 16px;
    }
  }
  .el-error {
    height: 100%;
    display: flex;
    align-items: center;
    color: #F56C6C !important;
    font-size: 10px;
    margin-right: 5px;
  }
  .drop-down-label{
    color: $gray;
  }

}
@include media('<=600px') {
  .form-controls{
    grid-template-columns: 1fr;
  }
}
.asterisk{
  color: $hk-danger;
}

</style>
